<template>
  <Dialog :open="open" @close="$emit('close')">
    <template v-slot:title>
      <FlexRow full-width justify="center">
        <Label type="title" text="保存した検索条件の設定" />
      </FlexRow>
    </template>
    <template v-slot:default>
      <FlexColumn>
        <FlexRow justify="center">
          <FlexColumn>
            <TextField v-model="name" name="検索条件名" />
          </FlexColumn>
        </FlexRow>
        <FlexRow justify="center">
          <TextButton
              outlined
              accent
              @click="handleDelete"
          >
            この検索条件を削除する
          </TextButton>
        </FlexRow>
      </FlexColumn>
    </template>
    <template v-slot:actions>
      <FlexRow full-width justify="center">
        <TextButton
            @click="$emit('close')"
        >
          キャンセル
        </TextButton>
        <TextButton
            primary
            @click="handleSave"
        >
          保存する
        </TextButton>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/atoms/Dialog";
import FlexRow from "@/components/atoms/FlexRow";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import TextButton from "@/components/atoms/TextButton";
import ApiMixin from "@/ApiMixin";
import {mapGetters} from "vuex";
import TextField from "../atoms/TextField";
export default {
  mixins: [ApiMixin],
  name: "ApplicantSearchConditionsSettingDialog",
  components: {TextField, TextButton, Label, FlexColumn, FlexRow, Dialog},
  props: {
    open: {
      type: Boolean
    },
    conditions: {
      type: Object
    }
  },
  data() {
    return {
      name: undefined
    }
  },
  computed: {
    ...mapGetters("client", ["company"]),
    conditionsName() {
      if (this.conditions) {
        return this.conditions.name
      }
      return ""
    }
  },
  methods: {
    handleDelete() {
      this.deleteChatRequestSearchConditions(this.company.id, this.conditions.id)
      this.$emit("close")
    },
    handleSave() {
      this.updateChatRequestSearchConditions(this.company.id, this.conditions.id, this.name)
      this.$emit("close")
    }
  },
  watch: {
    conditions: {
      handler(value) {
        if (value) {
          this.name = value.name
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
